import { render, staticRenderFns } from "./NewsModal.vue?vue&type=template&id=0560698a&scoped=true"
import script from "./NewsModal.vue?vue&type=script&lang=js"
export * from "./NewsModal.vue?vue&type=script&lang=js"
import style0 from "./NewsModal.vue?vue&type=style&index=0&id=0560698a&prod&lang=scss&scoped=true"
import style1 from "./NewsModal.vue?vue&type=style&index=1&id=0560698a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560698a",
  null
  
)

export default component.exports